export const racines = {
  logo_image_url: 'racines.png',
  header_background_url: 'racines/blue.png',
  logo_height: 100,

  button_color: '#43a6ae',
  button_radius: 50,
  button_half_border_color: '#812846',
  button_font: `'Open Sans', sans-serif`,
  button_text_weight: 700,

  text_font: `'Open Sans', sans-serif`,
  text_color: '#323548',
  title_font: `'Luckiest Guy', cursive`,
  title_weight: 300,
  title_color: '#323548',
}

export const racines_1 = {
  ...racines,
  token_url: 'racines/1.png',
  number_hidden: true,
}

export const racines_2 = {
  ...racines,
  token_url: 'racines/2.png',
  number_hidden: true,
}

export const racines_3 = {
  ...racines,
  token_url: 'racines/3.png',
  number_hidden: true,
}

export const racines_4 = {
  ...racines,
  token_url: 'racines/4.png',
  number_hidden: true,
}

export const racines_5 = {
  ...racines,
  token_url: 'racines/5.png',
  number_hidden: true,
}

export const racines_6 = {
  ...racines,
  token_url: 'racines/6.png',
  number_hidden: true,
}

export const racines_7 = {
  ...racines,
  token_url: 'racines/7.png',
  number_hidden: true,
}

export const racines_8 = {
  ...racines,
  token_url: 'racines/8.png',
  number_hidden: true,
}

export const racines_9 = {
  ...racines,
  token_url: 'racines/9.png',
  number_hidden: true,
}

export const racines_10 = {
  ...racines,
  token_url: 'racines/10.png',
  number_hidden: true,
}
